import { combineReducers } from 'redux';

import layout, { initialState as layoutState } from './layout';
import widget, { initialState as widgetState } from './widget';
import news, { initialState as newsState } from './news';
import menu, { initialState as menuState } from './menu';
import header, { initialState as headerState } from './header';
import user, { initialState as userState } from './user';
import miniWidget, { initialState as miniWidgetState } from './miniWidget';
import search, { initialState as searchState } from './search';
import events, { initialState as eventsState } from './events';
import audiences, { initialState as audiencesState } from './audiences';
import foodTickets, { initialState as foodTicketsState } from './foodTickets';
import payroll, { initialState as payrollState } from './payroll';
import notifications, {
  initialState as notificationsState
} from './notifications';
import pressRelease, {
  initialState as pressReleaseState
} from './pressRelease';

export const initialState = {
  layout: layoutState,
  widget: widgetState,
  news: newsState,
  menu: menuState,
  header: headerState,
  user: userState,
  miniWidget: miniWidgetState,
  search: searchState,
  events: eventsState,
  audiences: audiencesState,
  pressRelease: pressReleaseState,
  foodTickets: foodTicketsState,
  payroll: payrollState,
  notifications: notificationsState
};

const rootReducer = combineReducers({
  layout,
  menu,
  news,
  widget,
  header,
  user,
  miniWidget,
  search,
  events,
  audiences,
  pressRelease,
  foodTickets,
  payroll,
  notifications
});

export default rootReducer;
